// AI branch-generation tiers for the compose UI.
// Keep prices in sync with convex/ai.ts `AI_TIERS` (server-side source of truth).
export type AiTier = 'draft' | 'standard' | 'premium'

export const AI_TIER_OPTIONS: { id: AiTier; label: string; price: number; desc: string }[] = [
  { id: 'draft', label: 'Draft', price: 30, desc: 'Fast, lower cost' },
  { id: 'standard', label: 'Standard', price: 80, desc: 'Recommended' },
  { id: 'premium', label: 'Premium', price: 150, desc: 'Highest quality' },
]
